import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../../../../../core';
import { FunilVendaSearchFunilVenda } from '../../../../../funil-venda/funil-venda-search';
import { FunilVendaFaseSearch } from '../../../../../funil-venda/fase/funil-venda-fase-search';

@Component({
    selector: 'sgt-negocio-form-insert-step-funil',
    templateUrl: './negocio-form-insert-step-funil.component.html',
    styleUrls: ['./negocio-form-insert-step-funil.component.less']
})
export class NegocioFormInsertStepFunilComponent  {

    /** Se é o primeiro step */
    @Input() isFirstStep = false;

    // Funil de Venda
    @Input() canEditFunilVenda: boolean;
    @Input() tiposFunilVendaFasesFilter: number[] = null
    @Input() funilVenda: FunilVendaSearchFunilVenda;
    @Output() funilVendaChange = new EventEmitter<FunilVendaSearchFunilVenda>();
    @Input() idFunilVenda: number;
    @Output() idFunilVendaChange = new EventEmitter<number>();

    // Fase do funil de venda
    @Input() canEditFunilVendaFase: boolean
    @Input() funilVendaFase: FunilVendaFaseSearch;
    @Output() funilVendaFaseChange = new EventEmitter<FunilVendaFaseSearch>();
    @Input() idFunilVendaFase: number;
    @Output() idFunilVendaFaseChange = new EventEmitter<number>();
    @Input() tipoFunilVendaFase: number;
    @Output() tipoFunilVendaFaseChange = new EventEmitter<number>();

    @Output() previus = new EventEmitter<void>();
    @Output() next = new EventEmitter<void>();

    constructor(private messageService: MessageService) { }

    /** Ao alterar o funil de vendas */
    onChangeFunilVenda(funilVenda: FunilVendaSearchFunilVenda) {
        if (funilVenda) {
            this.idFunilVenda = funilVenda.id;
            this.funilVenda = funilVenda;

            // Selecionando a primeira fase do funil se o funil possuir ao menos uma fase e se a fase atualmente selecionada não existir no funil selecionado
            if (this.funilVenda && this.funilVenda.fases?.length > 0) {
                const fase = this.funilVenda.fases?.find(faseFilter => faseFilter.tipo === this.tipoFunilVendaFase);
                if (fase) {
                    this.onChangeTipoFunilVendaFase(fase);
                } else {
                    this.onChangeTipoFunilVendaFase(this.funilVenda.fases[0]);
                }
            }
        } else {
            this.idFunilVenda = null;
            this.funilVenda = null;
            this.clearFase();
        }


        this.funilVendaChange.emit(this.funilVenda);
        this.idFunilVendaChange.emit(this.idFunilVenda);
    }

    /** Ao alterar a fase funil de vendas */
    onChangeTipoFunilVendaFase(funilVendaFase: FunilVendaFaseSearch) {
        // Fase
        this.funilVendaFase = funilVendaFase;
        this.funilVendaFaseChange.emit(this.funilVendaFase);
        // ID
        this.idFunilVendaFase = funilVendaFase ? funilVendaFase.id : null;
        this.idFunilVendaFaseChange.emit(this.idFunilVendaFase);
        // Tipo
        this.tipoFunilVendaFase = funilVendaFase ? funilVendaFase.tipo : null;
        this.tipoFunilVendaFaseChange.emit(this.tipoFunilVendaFase);
    }

    /** Limpar a fase do funil de vendas */
    private clearFase() {
        // Fase
        this.funilVendaFase = null;
        this.funilVendaFaseChange.emit(this.funilVendaFase);
        // ID
        this.idFunilVendaFase = null;
        this.idFunilVendaFaseChange.emit(this.idFunilVendaFase);
        // Tipo
        this.tipoFunilVendaFase = null;
        this.tipoFunilVendaFaseChange.emit(this.tipoFunilVendaFase);
    }

    nextClick() {
        // Funil de venda
        if (!this.idFunilVenda) {
            this.messageService.warning('Selecione o funil de vendas para qual este novo negócio deve ser criado', 'Atenção');
            return;
        }

        // Fase do funil de venda
        if (!this.tipoFunilVendaFase) {
            this.messageService.warning('Selecione a fase do funil de vendas para qual este novo negócio deve ser criado', 'Atenção');
            return;
        }

        this.next.emit();
    }
}
